import React from "react"
import { TStepProps } from '@health-zelas/quiz'
import { Button, Container, Grid, Heading, Paragraph } from "@health-zelas/delta"

import { Radio, RequiredField, StateAndCityDropdown } from '@packages/components'

import ProgressBar from "../../components/ProgressBar"
import Step from "../../components/Step"

const Initial: React.FC<TStepProps> = ({ navigateToNextStep }) => {
  return (
    <Step>
      <Container css={{ paddingBottom: '$lg' }}>
        <Grid>
          <Grid.Item
            colSpans={{ sm: 12, md: 6, lg: 5 }}
            css={{
              display: 'block'
            }}
          >
            <ProgressBar title="Início" fill={1} />
            <Heading
              as="h1"
              size="lg"
              weight="bold"
              css={{
                marginBottom: '$xxs'
              }}
            >
              Simulador de planos Zelas Saúde
            </Heading>
            <Paragraph
              size="lg"
              color="$neutralDark"
              lineHeight="distant"
              css={{
                marginBottom: '$xs'
              }}
            >
              Em poucos passos você descobre os planos de saúde que melhor te atendem!
            </Paragraph>

            <Heading
              color="$neutralDark"
              size="sm"
              weight="bold"
              css={{
                marginBottom: '$xxs'
              }}
            >
              Procurando um plano odontológico?
            </Heading>
            <Paragraph
              size="lg"
              color="$neutralDark"
              lineHeight="distant"
              css={{
                marginBottom: '$md'
              }}
            >
            <a href="/simulador/planos-odonto">Clique aqui</a> e veja as opções disponíveis para você.
            </Paragraph>
          </Grid.Item>

          <Grid.Item
            colStarts={{ md: 7 }}
            colEnds={{ md: 13 }}
            css={{
              display: 'block'
            }}
          >
            <Heading
              color="$neutralDark"
              size="sm"
              weight="bold"
              css={{
                marginBottom: '$nano'
              }}
            >
              Como você pretende contratar o plano?
            </Heading>

            <Paragraph
              size="sm"
              color="$neutralDark"
              lineHeight="distant"
              css={{
                marginBottom: '$xxs',

                strong: {
                  fontWeight: '$bold',
                }
              }}
            >
              <strong>Economize até 40% </strong> contratando com um CNPJ ou MEI.
            </Paragraph>

            <Radio
              name="possui_cnpj"
              validator={RequiredField}
              options={[
                {
                  value: "Sim",
                  label: 'CNPJ/MEI',
                  id: 'cnpj'
                },
                {
                  value: "Não",
                  label: 'CPF',
                  id: 'cpf'
                }
              ]}
              css={{
                marginBottom: '$md'
              }}
            />

            <Heading
              color="$neutralDark"
              size="sm"
              weight="bold"
              css={{
                marginBottom: '$xxs'
              }}
            >
              Em qual região o plano será utilizado?
            </Heading>

            <StateAndCityDropdown />

            <Button
              size="large"
              onClick={navigateToNextStep}
              className="simulador"
              id="simulador_comecar"
              css={{
                marginTop: '$md'
              }}
            >
              Começar
            </Button>
          </Grid.Item>
        </Grid>
      </Container>
    </Step>
  )
}

export default Initial
